import { render, staticRenderFns } from "./newTopicFilter.vue?vue&type=template&id=4378f463&scoped=true&"
import script from "./newTopicFilter.vue?vue&type=script&lang=js&"
export * from "./newTopicFilter.vue?vue&type=script&lang=js&"
import style0 from "./newTopicFilter.vue?vue&type=style&index=0&id=4378f463&lang=less&scoped=true&"
import style1 from "./newTopicFilter.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4378f463",
  null
  
)

component.options.__file = "newTopicFilter.vue"
export default component.exports